import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireSuperAdmin = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div data-testid="auth-loading" className="text-slate-500 text-sm tracking-widest uppercase">
          Wird geladen…
        </div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  if (requireSuperAdmin && user.role !== "super_admin") {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
